<template>
  <div class="exchangeOfferBidsDashboard exchangeOfferBidsDashboard--admin">
    <div class="exchangeOfferBidsDashboard__header">
      <div class="exchangeOfferBidsDashboard__title">Exchange Offer Bids</div>
      <div class="exchangeOfferBidsDashboard__nav">
        <div class="exchangeOfferBidsDashboard__nav-container">
          <div
            class="exchangeOfferBidsDashboard__nav-item"
            :class="{'active': historical === false}"
            @click="switchMode(false)">
            <span class="text">Current</span>
          </div>
          <div
            class="exchangeOfferBidsDashboard__nav-item"
            :class="{'active': historical === true}"
            @click="switchMode(true)">
            <span class="text">Historical</span>
          </div>
        </div>
        <div class="exchangeOfferBidsDashboard__nav-container">
          <!-- <div class="exchangeOfferBidsDashboard__nav-item" @click="exportToExcel()">
            <span class="text">Export</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="exchangeOfferBidsDashboard__content">
      <div class="exchangeOfferBidsDashboard__content-item">
        <div class="exchangeOfferBidsDashboard__table">
          <div class="exchangeOfferBidsDashboard__table-header">
            <div class="exchangeOfferBidsDashboard__table-cell">№</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Created</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Offerer</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Model</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Offer</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Price</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Bidder</div>
            <div class="exchangeOfferBidsDashboard__table-cell">Bid</div>
          </div>
          <div class="exchangeOfferBidsDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of offersBidsList"
                :key="index"
                class="exchangeOfferBidsDashboard__table-row js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
                @click="getBidsByOfferId(item.id)"
              >
                <div class="exchangeOfferBidsDashboard__table-row-header js-acc-title">
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    <div class="exchangeOfferBidsDashboard__table-index">{{offersBidsList.length - index}}</div>
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    <span>{{getDisplayDateTime(item.createdOn)}}</span>
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offerCreator)"
                    class="exchangeOfferBidsDashboard__table-name">{{item.offerCreator.firstName + ' ' + item.offerCreator.lastName}}</a>
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    {{item.model}}
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    {{item.offerName}}
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    {{getPrice(item)}}
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.bidder)"
                    class="exchangeOfferBidsDashboard__table-name">{{item.bidder.firstName + ' ' + item.bidder.lastName}}</a>
                  </div>
                  <div class="exchangeOfferBidsDashboard__table-cell">
                    {{getBidAndSpaces(item)}}
                  </div>
                </div>
                <!-- <div class="exchangeOfferBidsDashboard__table-row-control js-acc-hover-content">
                  <div class="exchangeOfferBidsDashboard__table-row-control-inner ">
                    <p class="exchangeOfferBidsDashboard__table-link" @click="(e) => deleteOfferBidClick(e, item)">
                      <span class="icon" />
                      <span class="text">Delete</span>
                    </p>
                  </div>
                </div> -->
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </div>
    <FlyerDetailsPopup />
    <QuestionPopup
      :name="'QuestionPopupDelete'"
      :title="'The offer bid will be deleted'"
      :text="'Are you sure?'"
      @remove="deleteOfferBid"
    />
    <InfoPopup/>
    <Teleport to="body">
      <OfferBidsPopup/>
    </Teleport>
  </div>
</template>

<script>
  // import { reportsAPI } from '@/api/reports'
  import Teleport from 'vue2-teleport';
  import FlyerDetailsPopup from '@/components/common/modals/FlyerDetailsPopup'
  import OfferBidsPopup from '@/components/common/modals/OfferBidsPopup.vue';
  import QuestionPopup from '@/components/common/modals/QuestionPopup'
  import InfoPopup from '@/components/common/modals/InfoPopup.vue';
  import './ExchangeOfferBids.styl'
  import moment from 'moment'

  export default {
    name: 'exchangeMembershipApps',
    data: () => ({
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      currentItem: null,
      historical: false,
    }),
    computed: {
      offersBidsList () {
        return this.$store.state.exchangeOffers.offersBidsList
      },
    },
    async mounted () {
      await this.switchMode(false);
    },
    methods: {
      controlShow (event) {
        const item = event.currentTarget.closest('.exchangeOfferBidsDashboard__table-row').querySelector('.js-acc-hover-content')
        this.$root.animations.slideDown(item)
        item.classList.add('show')
      },
      controlHide (event) {
        const item = event.currentTarget.closest('.exchangeOfferBidsDashboard__table-row').querySelector('.js-acc-hover-content')
        item.classList.remove('show')
        this.$root.animations.slideUp(item)
      },
      openAdditionalDetails (e, account) {
        e.stopPropagation()
        this.$modal.show('FlyerDetailsPopup', {additionalInfo: account})
      },
      moment,
      getBidAndSpaces (item) {
        if (item.numberOfUnits) {
          return item.bidValue * item.numberOfUnits + ' for ' + item.numberOfUnits + ' space' + (item.numberOfunits > 1 ? 's' : '');
        } else {
          return item.bidValue;
        }
      },
      getPrice (item) {
        if (item.numberOfUnits) {
          return item.price + ' per space'
        } else {
          return item.price
        }
      },
      getDisplayDateTime (dateString) {
        if (!dateString) {
          return ''
        }
        const options = {timeZone: 'America/New_York', hour12: false};
        let date = new Date(dateString);
        date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return dateString === null
          ? ''
          : date.toLocaleString('en-US', options);
      },
      deleteOfferBidClick (e, item) {
        e.stopPropagation();
        this.currentItem = item;
        this.$modal.show('QuestionPopupDelete');
      },
      async deleteOfferBid () {
        // const res = await this.$store.dispatch('deleteOffer', this.currentItem.id);
        // console.log(res)
        //   if (!res.isSuccessfull) {
        //     this.$modal.show('InfoPopup', {
        //       title: 'Error',
        //       text: res.message,
        //     });
        //   } else {
        //     this.$router.go();
        //   }
        //   this.currentItem = null;
        //   this.$modal.hide('QuestionPopupDelete')
      },
      async switchMode (historical) {
        this.historical = historical;
        await this.$store.dispatch('getOffersBidsList', historical);
      },
    },
    components: {
      FlyerDetailsPopup,
      OfferBidsPopup,
      QuestionPopup,
      InfoPopup,
      Teleport,
    },
  }
</script>